import { styled } from "styled-components";

import SectionTitle from "../atoms/SectionTitle";
import Section, { StyledSectionImage } from "../molecules/Section";

import WorksImage from "../../assets/icons/works.svg";

const Works = () => {
  return (
    <Section id="works">
      <SectionTitle title="works" />
      <StyledSectionImage src={WorksImage} alt="" />

      <StyledUL>
        <li>
          <a href="https://brifagoai.com">
            <span>BrifagoAI</span>
          </a>
        </li>
        <li>
          <a href="https://builsy.vercel.app">
            <span>Builsy</span>
          </a>
        </li>
        <li>
          <a href="https://beeestrest.vercel.app/en">
            <span>BeeestRest</span>
          </a>
        </li>
        {/* <li>
          <a href="https://linksooon.vercel.app/">
            <span>Linksooon</span>
          </a>
        </li> */}
        <li>
          <a href="https://obiekty-sportowe.vercel.app/">
            <span>SPORTS FACILITIES</span>
          </a>
        </li>
        {/* <li>
          <a href="https://okazjeonline.vercel.app/">
            <span>OKAZJE ONLINE</span>
          </a>
        </li> */}
        {/* <li>
          <a href="https://saved-links-nextjs.vercel.app/">
            <span>SAVED LINKS</span>
          </a>
        </li> */}
        <li>
          <a href="https://mojepojazdy.netlify.app/">
            <span>MY VEHICLES</span>
          </a>
        </li>
        <li>
          <a href="https://github.com/KarolG99/przygotowka">
            <span>PRZYGOTOWKA</span>
          </a>
        </li>
        <li>
          <a href="https://waldus.netlify.app/">
            <span>WALDUS</span>
          </a>
        </li>
        <li>
          <a href="https://jedzenieonline.netlify.app/">
            <span>ORDER ONLINE</span>
          </a>
        </li>
        <li>
          <a href="https://huggingface.co/spaces/GKarol/bear-classifier">
            <span>BEARS CLASSIFIER</span>
          </a>
        </li>
        <li>
          <a href="https://huggingface.co/spaces/GKarol/cats-vs-dogs">
            <span>DOG/CAT CLASSIFIER</span>
          </a>
        </li>
        <li>
          <a href="https://github.com/KarolG99">
            <span>CHECK GITHUB</span>
          </a>
        </li>
      </StyledUL>
    </Section>
  );
};

const StyledUL = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  text-transform: uppercase;
  margin-top: 48px;
  font-weight: 900;
  font-size: 24px;
  color: ${({ theme }) => theme.colors.primaryText07};

  li {
    border-top: 1px solid ${({ theme }) => theme.colors.primaryText02};
    position: relative;
    overflow: hidden;
    transition: color 0.4s cubic-bezier(0.61, 0.07, 0.23, 0.89);
    a {
      text-decoration: none;
      color: ${({ theme }) => theme.colors.primaryText07};
      transition: color 0.4s cubic-bezier(0.61, 0.07, 0.23, 0.89);
      cursor: pointer;
      white-space: nowrap;
    }
    span {
      position: relative;
      z-index: 3;
    }
    &::after {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      background-color: ${({ theme }) => theme.colors.highlightedText};
      left: 0;
      top: 0;
      transform: scaleX(0);
      transform-origin: 0 50%;
      transition: transform 0.4s cubic-bezier(0.61, 0.07, 0.23, 0.89);
      z-index: 1;
    }
    &:hover {
      color: ${({ theme }) => theme.colors.bg};
      a {
        color: ${({ theme }) => theme.colors.bg};
      }
      &::after {
        transform: scaleX(1);
      }
    }
  }
  li:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.colors.primaryText02};
  }

  @media (min-width: 335px) {
    font-size: 28px;
  }
  @media (min-width: 500px) {
    font-size: 32px;
  }
  @media (min-width: 750px) {
    font-size: 38px;
  }
  @media (min-width: 1000px) {
    font-size: 48px;
  }
`;

export default Works;
